import { store } from '@redux/store';
import { selectAdditionalHomes, selectBooking } from '../redux/selectors';
import { closeModal, setModalStep } from '../redux/slices';
import { checkIconSvgElement, utourArrowSvgElement } from '../constants/svgIcons';

import ModalStep from '../enums/modalStep';

export default class Confirmation {
  class = '';

  constructor(rootComponent) {
    this.nextStep = null;
    this.previousStep = ModalStep.Questions;
    this.rootComponent = rootComponent;
  }

  /**
   * Handles the primary action for the tour configuration.
   * Dispatches an action to update the modal step in the store with the next step.
   *
   */
  handlePrimaryAction() {
    store.dispatch(closeModal({ modalStep: this.nextStep }));
  }

  /**
   * Handles the secondary action by dispatching an action to update the modal step
   * to the previous step in the application's state.
   *
   */
  handleSecondaryAction() {
    store.dispatch(setModalStep({ modalStep: this.previousStep }));
  }

  render() {
    const state = store.getState();
    const booking = selectBooking(state);
    const additionalHomes = selectAdditionalHomes(state);
    const homeCollection = this.rootComponent.otherHomes;
    const spec = this.rootComponent.getSpecDetails();

    // we create an array of object the same shape, to easily map the data later
    const homes = [{PlanName: spec.planName, Address: spec.address }]
      .concat(additionalHomes.map(id => homeCollection[id]));

    return `
      <div class="nhs-c-self-guided-left-panel ${this.class}">
        <h1 class="nhs-c-heading--self-guided-tour nhs-mq-heading--self-guided-tour-large">
          <span class="nhs-c-icon-utour-check nhs-mq-icon-utour-check--56-large nhs-mq-display--none-large-max">
            ${checkIconSvgElement}
          </span>
          Your self-tour is scheduled!</h1>

        <div class="nhs-c-notification__placeholder" data-self-guided-tour-notifications></div>

        <p class="nhs-c-label--black-900-body-1-medium-regular">A confirmation email with your detailed itinerary has been sent to you.</p>

        <div class="nhs-c-image--arrow-right nhs-mq-display--none-large-max">
          ${utourArrowSvgElement}
        </div>

        <div class="nhs-c-card--utour-confirm">

          <h3 class="nhs-c-heading--black-1000-souvenir-heading-1-extra-large-light">Entry code: ${booking.DoorAccessCode}</h3>

          <ul class="nhs-o-flex-column-items-start nhs-u-gap--300">
            ${homes.map(home => (
              `<li class="nhs-c-heading--black-1000-sans-subhead-1-large-medium">${home.PlanName} at ${home.Address}</li>`
            )).join('')}
            
          </ul>

          <p class="nhs-c-label--black-900-body-1-medium-regular">If you enter the code incorrectly, press the reset button and enter the code again. Your entry code will expire 30 minutes after the scheduled start time.</p>
          
        </div>
      </div>
    `;
  }
}
